import React from 'react';
import { I18n } from 'react-redux-i18n';
import {
  Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';

import OneClickButton from '../../../../components/form/button';
import Form from '../../../../components/form/form';
import addNotification from '../../../../components/notification';

const MAX_LABELS = 999;

class ConfirmModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      copiesPerCombination: '1',
      printOrder: 'asc',
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.showConfirmModal && this.props.showConfirmModal !== prevProps.showConfirmModal) {
      this.setState({
        copiesPerCombination: '1',
        printOrder: 'asc',
      });
    }
  }

  setValue = (attr, value) => {
    if (attr === 'copiesPerCombination') {
      if (value === '' || /^[0-9]+$/.test(value)) {
        this.setState({
          copiesPerCombination: value,
        });
      }
      return;
    }

    this.setState({
      [attr]: value,
    });
  };

  getCopiesPerCombination = () => {
    const { copiesPerCombination } = this.state;
    const copies = parseInt(copiesPerCombination, 10);
    return copies > 0 ? copies : 0;
  };

  getTotalLabels = () => {
    const { combinationCount = 0 } = this.props;
    return combinationCount * this.getCopiesPerCombination();
  };

  submitConfirm = () => {
    const { printOrder } = this.state;
    const copies = this.getCopiesPerCombination() || 1;
    const total = this.getTotalLabels();

    if (total > MAX_LABELS) {
      addNotification(
        'danger',
        I18n.t('BEE4197' /* Confirmar impressão de Etiqueta de Embalagem Fracionada */),
        I18n.t(
          'BEE4832',
          { 0: total },
          // eslint-disable-next-line
          /* A impressão está limitada a 999 etiquetas por vez. A seleção atual totaliza %{0} etiquetas, considerando a quantidade de cópias informada. Restrinja os filtros para que o total seja de, no máximo, 999 etiquetas e tente novamente. */
        ),
        'top-right',
      );
      return;
    }

    this.props.onConfirm({
      copiesPerCombination: copies,
      printOrder,
    });
  };

  render() {
    const { showConfirmModal = false, combinationCount = 0 } = this.props;
    const { copiesPerCombination, printOrder } = this.state;
    const totalLabels = this.getTotalLabels();

    return (
      <Modal size="md" isOpen={showConfirmModal} toggle={this.props.closeConfirm} className="adjustmentPadding">
        <ModalHeader toggle={this.props.closeConfirm}>
          {I18n.t('BEE4197' /* Confirmar impressão */)}
        </ModalHeader>
        <ModalBody>
          <div style={{ marginTop: 20 }}>
            <Form
              noPanel
              isModal
              setValue={this.setValue}
              inputs={(formContext) => ([
                formContext.createInput(
                  copiesPerCombination,
                  'copiesPerCombination',
                  `${I18n.t('BEE4828' /* Quantidade de etiquetas por combinação */)} `,
                  '1',
                  'number',
                  false,
                  false,
                  {
                    id: 'fractionalPackagingCopiesPerCombinationTooltip',
                    // eslint-disable-next-line
                    content: I18n.t('BEE4830' /* Por padrão, será impressa 1 etiqueta por combinação. Para imprimir mais cópias de cada combinação, altere a quantidade ao lado. */),
                  },
                  undefined,
                  undefined,
                  null,
                  3,
                ),
                formContext.createInput(
                  totalLabels,
                  'totalLabels',
                  `${I18n.t('BEE2788' /* Total de Etiquetas */)}`,
                  '',
                  'number',
                  false,
                  true,
                  undefined,
                  undefined,
                  undefined,
                  null,
                  4,
                ),
                formContext.createRadioButtons(
                  [{
                    label: I18n.t('BEE3461' /* Ascendente */),
                    value: 'asc',
                  }, {
                    label: I18n.t('BEE3462' /* Descendente */),
                    value: 'desc',
                  }],
                  printOrder,
                  'printOrder',
                  `${I18n.t('BEE4831' /* Ordem de Impressão — Código do Endereço */)}`,
                  undefined,
                  undefined,
                  'm-l-10',
                  ['col-md-12'],
                ),
              ])}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          {totalLabels > MAX_LABELS && (
          <span className="text-danger">
            {I18n.t(
              'BEE4833' /* Limite de etiquetas excedido (%{0}) */,
              { 0: MAX_LABELS },
            )}
          </span>
          )}
          <button
            type="button"
            className="btn btn-120 btn-white p-5 m-5"
            onClick={this.props.closeConfirm}
          >
            {I18n.t('BEE99' /* Cancelar */)}
          </button>
          <OneClickButton
            type="button"
            className="btn btn-120 btn-primary p-5 m-5"
            onClick={this.submitConfirm}
            disabled={combinationCount === 0 || totalLabels === 0 || totalLabels > MAX_LABELS}
          >
            {I18n.t('BEE100' /* Confirmar */)}
          </OneClickButton>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ConfirmModal;
